import { render, staticRenderFns } from "./StockdogShowResultsEntry.vue?vue&type=template&id=5637771f"
import script from "./StockdogShowResultsEntry.vue?vue&type=script&lang=ts"
export * from "./StockdogShowResultsEntry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports